import { Box, Button } from '@chakra-ui/react';
import { useState } from 'react';

import InputSelectComponent from 'UiKit/input-select';
import { TextRegular, TextSemiBold } from 'UiKit/typography';
import { ChevronLeftIcon, ChevronRightIcon } from 'Asset/icon';

import { pageSizeOptions } from './const';

import styles from './styes.module.css';
import { Condition, Iteration } from 'Component/others';
import PaginationSkeleton from 'Component/skeleton/pagination';

const Pagination = ({
  pageSize = 10,
  onChange = () => {},
  onSizeChange = () => {},
  totalData = 1,
  isShowChangePageSize = false,
  className = '',
  currentPage,
  isLoading,
}) => {
  const [size, setSize] = useState({ label: pageSize.toString(), value: pageSize });
  const totalPages = Math.max(1, Math.ceil(totalData / pageSize));
  const arrayPages = Array.from({ length: totalPages }, (_, i) => i + 1);
  const showElipsisNext = totalPages > 5 && currentPage < totalPages - 2;
  const showElipsisPrev = totalPages > 5 && currentPage > 3;
  const isDisabledPrevButton = currentPage === 1;
  const isDisabledNextButton = currentPage === totalPages;

  const isShowButton = (pageNo) => {
    const bothElipsis = showElipsisNext && showElipsisPrev ? 2 : 3;
    return pageNo !== 1 && pageNo !== totalPages && pageNo > currentPage - bothElipsis && pageNo < currentPage + bothElipsis;
  };

  const handleChangePage = (pageNo) => {
    onChange(pageNo);
  };

  const handlePageSize = (e) => {
    setSize(e);
    onSizeChange(e.value);
  };

  return (
    <Box className={`${styles['pagination__container']} ${className}`}>
      <Condition statement={isShowChangePageSize}>
        <Box className={styles['pagination__page-size-container']}>
          <TextRegular className={styles['pagination__page-size-text']}>Item Per Page</TextRegular>
          <InputSelectComponent value={size} options={pageSizeOptions} onChange={handlePageSize} />
        </Box>
      </Condition>
      <Condition statement={!isLoading} fallback={<PaginationSkeleton />}>
        <Box className={styles['pagination__page-change-container']} data-testid="pagination__page-change-container">
          <Button className={styles['pagination__page-change-button']} disabled={isDisabledPrevButton} onClick={() => handleChangePage(currentPage - 1)}>
            <ChevronLeftIcon size="16px" color={isDisabledPrevButton ? 'var(--color-neutral40)' : 'var(--color-semantic-text)'} />
            <TextSemiBold>Prev</TextSemiBold>
          </Button>
          <Box className={styles['pagination__button-page-number-container']}>
            <Button
              className={`${styles['pagination__button-page-number']} ${currentPage === 1 && styles['pagination__current-page-button']}`}
              disabled={currentPage === 1}
              onClick={() => handleChangePage(1)}
            >
              <TextRegular
                className={`${styles['pagination__button-page-number-text']} 
              ${currentPage === 1 && styles['pagination__current-page-button-text']}`}
              >
                1
              </TextRegular>
            </Button>
            <Condition statement={showElipsisPrev}>
              <TextRegular className={`${styles['pagination__button-page-number-text-elipsis']}`}>...</TextRegular>
            </Condition>
            <Iteration
              items={arrayPages}
              render={(page) => {
                return isShowButton(page) ? (
                  <Button
                    key={page}
                    className={`${styles['pagination__button-page-number']} 
                  ${page === currentPage && styles['pagination__current-page-button']}`}
                    onClick={() => handleChangePage(page)}
                  >
                    <TextRegular
                      className={`${styles['pagination__button-page-number-text']} 
                    ${page === currentPage && styles['pagination__current-page-button-text']}`}
                    >
                      {page}
                    </TextRegular>
                  </Button>
                ) : null;
              }}
            />

            <Condition statement={showElipsisNext}>
              <TextRegular className={`${styles['pagination__button-page-number-text-elipsis']}`}>...</TextRegular>
            </Condition>

            <Condition statement={totalPages !== 1}>
              <Button
                className={`${styles['pagination__button-page-number']} 
              ${totalPages === currentPage && styles['pagination__current-page-button']}`}
                disabled={currentPage === totalPages}
                onClick={() => {
                  handleChangePage(totalPages);
                }}
              >
                <TextRegular
                  className={`${styles['pagination__button-page-number-text']} 
                ${totalPages === currentPage && styles['pagination__current-page-button-text']}`}
                >
                  {totalPages}
                </TextRegular>
              </Button>
            </Condition>
          </Box>
          <Button className={styles['pagination__page-change-button']} disabled={isDisabledNextButton} onClick={() => handleChangePage(currentPage + 1)}>
            <TextSemiBold>Next</TextSemiBold>{' '}
            <ChevronRightIcon size="16px" color={isDisabledNextButton ? 'var(--color-neutral40)' : 'var(--color-semantic-text)'} />
          </Button>
        </Box>
      </Condition>
    </Box>
  );
};

export default Pagination;
